import { Box, Card, CardContent, IconButton, Skeleton, Tooltip, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	getConfirmedOrders,
	getConfirmedOrdersLoader,
	getOrderDetailsCombined,
	getOrderDetailsCombinedLoader,
} from 'redux/reducers/orders/selectors';
import AddBoxIcon from '@mui/icons-material/AddBox';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import { OrderReturnsItem } from './OrderReturnsItem';
import { COLORS } from 'services/constants/colors';

export const OrderReturns: FC = () => {
	const orders = useSelector(getConfirmedOrders);
	const ordersIsLoading = useSelector(getConfirmedOrdersLoader);
	const orderDetailsCombined = useSelector(getOrderDetailsCombined);
	const orderDetailsCombinedIsLoading = useSelector(getOrderDetailsCombinedLoader);
	const orderReturns = orderDetailsCombined?.orderReturns;

	const [detalization, setDetalization] = useState(false);
	const handleDetalization = () => {
		setDetalization(!detalization);
	};

	return (
		<div>
			{!!orders?.data?.length &&
				!ordersIsLoading &&
				!orderDetailsCombinedIsLoading &&
				!!orderReturns?.length && (
					<Card
						sx={{
							mb: 2,
							'&': {
								borderRadius: '12px',
							},
						}}
					>
						<CardContent>
							<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<Typography sx={{ fontSize: 14 }} color={COLORS.PRIMARY} gutterBottom>
									Returns
								</Typography>
								{detalization ? (
									<Tooltip title="Hide more details">
										<IconButton size="small" color="primary" onClick={handleDetalization}>
											<IndeterminateCheckBoxIcon />
										</IconButton>
									</Tooltip>
								) : (
									<Tooltip title="Show more details">
										<IconButton size="small" color="primary" onClick={handleDetalization}>
											<AddBoxIcon />
										</IconButton>
									</Tooltip>
								)}
							</Box>

							{orderReturns.map((item) => (
								<OrderReturnsItem
									key={item.id}
									orderReturnsItem={item}
									detalization={detalization}
									returnedOrderBreakdown={item.orderReturnItems}
								/>
							))}
							{orderReturns.length > 1 && (
								<Box
									sx={{
										mt: 1.5,
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										border: '1px solid #00000020',
										borderRadius: '12px',
										padding: '10px',
									}}
								>
									<Typography variant="h6" sx={{ fontWeight: 'bold' }} color="primary">
										Total Return Amount:
									</Typography>
									<AmountAndCurrency
										amount={orderReturns.reduce(
											(accumulator, item) => accumulator + (item.totalReturnAmount ?? 0),
											0,
										)}
										currency={orders?.data?.[0]?.paymentCurrency}
										bold
										size={1.3}
										color="primary"
									/>
								</Box>
							)}
						</CardContent>
					</Card>
				)}
			{(ordersIsLoading || orderDetailsCombinedIsLoading) && (
				<Skeleton variant="rectangular" height="300px" sx={{ borderRadius: '12px', mb: 2 }} />
			)}
		</div>
	);
};
